import React from "react";
import { useTranslation } from "react-i18next";
import { Identifiable } from "../../../models/Identifiable";
import getId from "../../../../utils/getId";
import EAAlert from "../../shared/EAAlert";

interface IProps {
  humanName: string;
  humanPicture: string;
  deputyHumanIds: Identifiable;
  deputyHumanName: string;
}

const CoachInfo: React.FC<IProps> = ({ humanName, humanPicture, deputyHumanIds, deputyHumanName }) => {
  const { t } = useTranslation();

  if (humanName && humanName.length > 1) {
    return (
      <div className="coach ">
        <div
          className={`coach-img ${humanPicture.length <= 1 ? "coach-img-none" : ""}`}
          style={humanPicture.length ? { backgroundImage: `url(${humanPicture})` } : undefined}
        />

        <div className="coach-details">
          {getId(deputyHumanIds) ? (
            <>
              <EAAlert type="warning" message={t("zastepstwo")} compact />
              <b>
                <s>{humanName}</s> {deputyHumanName}
              </b>
            </>
          ) : (
            <b>{humanName}</b>
          )}
          <span>{t("trener_opiekun")}</span>
        </div>
      </div>
    );
  }

  return <></>;
};

export default CoachInfo;
